import React, { useState } from "react";
import styled from "styled-components";
import {
  Box,
  Button,
  Heading,
  Image,
  Link,
  Text,
  Flex,
} from "rebass/styled-components";
import Page from "../../components/Page";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import Table from "../../components/Table";
import ContentBox from "../../components/ContentBox";
import ReactPlayer from "react-player";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-regular-svg-icons";

const ImageBox = styled(Image)`
  padding: 0;
  width: 100%;
  vertical-align: middle;
`;

const imgPath = "https://merletimages.imgix.net/";

const Mondmaskers = ({ pageContent, lang }) => {
  const createMarkup = (content) => {
    return { __html: content };
  };

  return (
    <Page
      title="MERLET | Herbruikbare Mondmaskers"
      description="100% katoen – uitwasbaar op minimum 60°C, gemaakt in ons eigen atelier, al dan niet gepersonaliseerd."
    >
      <Header />
      <ContentBox bg="gold" maxWidth="inherit" pt="130px" textAlign="center">
        <Heading variant="title" color="black" textAlign="center">
          PBM
        </Heading>
        <Box variant="slogan">Herbruikbare mondmaskers</Box>
        <Heading variant="title" color="black" textAlign="center">
          GEMAAKT IN ONS EIGEN ATELIER
        </Heading>
      </ContentBox>
      <ContentBox>
        <Flex
          my="5"
          sx={{ flexDirection: ["column", "row", "row"], textAlign: "center" }}
        >
          <Box p={2} width={[1, 1 / 2, 1 / 2]}>
            <Image
              src="https://merletimages.imgix.net/mondmasker-tile.jpg"
              maxWidth={["250px", "100%"]}
            />
          </Box>
          <Box p={2} width={[1, 1 / 2, 1 / 2]}>
            <Image
              src="https://merletimages.imgix.net/mondmaskers-varianten.jpg"
              maxWidth={["250px", "100%"]}
            />
          </Box>
        </Flex>
        <Flex
          my="5"
          sx={{ flexDirection: ["column", "row", "row"], textAlign: "left" }}
        >
          <Box width={[1, 1 / 2, 1 / 2]}>
            <Box pb={1} variant="title" sx={{ color: "dark" }}>
              SPECIFICATIES:
            </Box>
            <Box fontSize={"18px"}>
              <Text as="ul" mt={2}>
                <Text as="li">Gemaakt uit dubbele katoen</Text>
                <Text as="li">
                  Opvulling mogelijk met filtermateriaal dat daarvoor schikt is
                </Text>
                <Text as="li">
                  De opening voor de eventuele opvulling zit bovenaan aan de
                  binnenkant
                </Text>
                <Text as="li">
                  Uitgevoerd met sluiting via lintjes want een rek gaat maar
                  enkele wasbeurten mee
                </Text>
                <Text as="li">
                  De maskers zijn volledig wasbaar op 60° tot 90°C
                </Text>
                <Text as="li">
                  Eventuele zelf aangebracht extra filter zeker verwijderen voor
                  het wassen
                </Text>
              </Text>
            </Box>
          </Box>
          <Box width={[1, 1 / 2, 1 / 2]}>
            <Box pb={1} variant="title" sx={{ color: "dark" }}>
              DIRECT LEVERBAAR IN VOLGENDE KLEUREN:
            </Box>
            <Box fontSize={"18px"}>
              <Text display="flex" flexWrap="wrap">
                <Text p="2" mr="2" mt="2" bg="gold">
                  lichtblauw
                </Text>
                <Text p="2" mr="2" mt="2" bg="gold">
                  donkerblauw
                </Text>
                <Text p="2" mr="2" mt="2" bg="gold">
                  jeans
                </Text>
                <Text p="2" mr="2" mt="2" bg="gold">
                  wit
                </Text>
                <Text p="2" mr="2" mt="2" bg="gold">
                  geel
                </Text>
                <Text p="2" mr="2" mt="2" bg="gold">
                  crème
                </Text>
              </Text>
            </Box>
          </Box>
        </Flex>
      </ContentBox>
      <ContentBox bg="duckEggBlue">
        <Box display="flex" flexWrap="wrap" my={4}>
          <Box flexBasis={["100%", "50%"]} mt={2}>
            <Heading variant="title" as="h2" mb="2" sx={{ color: "dark" }}>
              PRIJZEN
            </Heading>
            <Table sx={{ bg: "gold" }}>
              <thead>
                <tr>
                  <th></th>
                  <th> Per stuk, excl. 6% BTW</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>Vanaf 10 stuks</th>
                  <td>€ 3,96</td>
                </tr>
                <tr>
                  <th>Vanaf 50 stuks</th>
                  <td>€ 3,49</td>
                </tr>
                <tr>
                  <th>Vanaf 100 stuks</th>
                  <td>€ 3,21</td>
                </tr>
                <tr>
                  <th>250 stuks</th>
                  <td>€ 2,92</td>
                </tr>
                <tr>
                  <th>500 stuks</th>
                  <td>€ 2,74</td>
                </tr>
                <tr>
                  <th>1000 stuks</th>
                  <td>€ 2,50</td>
                </tr>
              </tbody>
            </Table>
          </Box>
          <Box flexBasis={["100%", "50%"]} mt={5} pl={[0, 4]}>
            <Text mb={3}>
              Wanneer u liever mondmaskers hebt met rekken ipv linten komt er €1
              extra bij.
            </Text>
            <Text mb={3}>
              Als u graag uw logo op uw masker ziet verschijnen kan dit door
              middel van zeefdruk (1 kleur) of via transfer of borduring
              (meerdere kleuren) en dit op de volgende kleuren van maskers:
              donkerblauw, lichtblauw, geel, wit en crème. De prijzen hiervoor
              zijn op aanvraag beschikbaar.
            </Text>
            <Text mb={3}>
              Voor diegenen die het knopen van de maskers lastig vinden kan je
              ook gebruik maken van koordstoppers zodat je gemakkelijk het
              masker op en af kan zetten.
            </Text>
            <Text mb={3}>Prijs is €0,47/stuk of €0,94/paar.</Text>
            <Box>
              <Image
                src="https://merletimages.imgix.net/koordstoppers.png"
                maxWidth="150px"
              />
            </Box>
          </Box>
        </Box>
        <Box display="flex" flexWrap="wrap" my={4}>
          <Box flexBasis={["100%", "50%"]} mt={2}>
            <Heading variant="title" as="h2" mb="2" sx={{ color: "dark" }}>
              LEVERING
            </Heading>
            <Text as="ul" mt={2}>
              <Text as="li">
                Af te halen in Oud-Turnhout of Kasterlee met voorafbetaling
              </Text>
              <Text as="li">Verzending via GLS, transportkost op aanvraag</Text>
            </Text>
          </Box>
          <Box flexBasis={["100%", "50%"]} mt={2} pl={[0, 4]}>
            <Heading variant="title" as="h2" mb="2" sx={{ color: "dark" }}>
              BETALINGSVOORWAARDE
            </Heading>
            <Text as="ul" mt={2}>
              <Text as="li">
                Voorafbetaling op rek. BE67 2300 3278 3087
                <br />+ vermelding naam besteller
              </Text>
            </Text>
          </Box>
        </Box>
        <Box pt={4}>
          <Heading variant="title" as="h2" mb="2" sx={{ color: "dark" }}>
            INSTRUCTIES:
          </Heading>
          <Link
            href="https://merletstorage.blob.core.windows.net/files/mondmasker-gebruiksaanwijzing.pdf"
            target="_blank"
          >
            <Text mb={2}>
              Handleiding in PDF{" "}
              <Text
                display="inline"
                ml={2}
                sx={{ "&:hover": { color: "red" } }}
              >
                <FontAwesomeIcon icon={faFilePdf} />
              </Text>
            </Text>
          </Link>
        </Box>
      </ContentBox>
      {/* <ContentBox>
        <Heading variant="title" as="h2" mb="2" sx={{ color: "dark" }}>
          INSTRUCTIES:
        </Heading>
        <Link
          href="https://merletstorage.blob.core.windows.net/files/mondmasker-gebruiksaanwijzing.pdf"
          target="_blank"
        >
          <Text mb={2}>
            Handleiding in PDF{" "}
            <Text display="inline" ml={2} sx={{ "&:hover": { color: "red" } }}>
              <FontAwesomeIcon icon={faFilePdf} />
            </Text>
          </Text>
        </Link>
        <Box py={3}>
          <ReactPlayer
            url="https://merletimages.imgix.net/mondmasker.mp4"
            controls={true}
            width="100%"
            height="500px"
            playing
            light="https://merletimages.imgix.net/Mondmaskers-gebruiksaanwijzing-afbeelding.jpg"
          />
        </Box>
      </ContentBox> */}

      <Box
        py="53px"
        maxWidth="inherit"
        textAlign="center"
        sx={{ bg: "duckEggBlue" }}
      >
        <Box
          min-height="96px"
          //maxWidth="792px"
          mx="auto"
          px="3"
          mb="4"
          sx={{ color: "dark", fontSize: "5", lineHeight: "1.17" }}
        >
          Te bestellen via
        </Box>
        <Link href="mailto:pascale@merlet.be">
          <Button variant="buttons.primary">pascale@merlet.be</Button>
        </Link>
      </Box>
      <Footer />
    </Page>
  );
};

export default Mondmaskers;
